import Icons from '@/icons';
import context from '@/services/ctx';
import channel from '@/cqs/channel';
import * as queries from  '@/cqs/queries'
import {getDataForCardFront, getDataForCardBack, checkAccess} from '@/services/storiesonboardrepository';
import config from '@/services/config';


class AnnotationsModule implements ICardBadgesProvider,ICardDetailsBadgesProvider {

    public async getCardBadges(t: ITrelloClient, opts:any) : Promise<Array<any>> {
        var badges = [];
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            if (cfg.isShowAnnotations && cfg.isShowAnnotationsOnCardFront){
                var card = await getDataForCardFront(t, opts.context.card);
                if(card != null) {
                    if(card.Annotations != null) {
                        var annotations = [...card.Annotations];
                        if(card.Color != null) {
                            annotations.push(card.Color);
                        }
                        var visibleAnnotations = await config(t).applyAnnotationFilter(annotations);
                        badges = visibleAnnotations.select(x => <any>{text: x.truncate(22), icon: Icons.Annotations.BadgeIcon});
                    }
                }
            }
        }
        
        return badges;
    }

    public async getCardDetailsBadges(t: ITrelloClient, opts: any): Promise<any[]> {
        var badges = [];
        var hasAccess = await checkAccess(t);
        if(hasAccess) {
            var ctx = await context(t).get();
            var cfg = ctx.config;
            if(cfg.isShowAnnotations && cfg.isShowAnnotationsOnCardBack) {
                var card = await getDataForCardBack(t, opts.context.card);
                if(card != null) {
                    if(card.Annotations != null) {
                        var visibleAnnotations = await config(t).applyAnnotationFilter(card.Annotations);
                        badges = visibleAnnotations.select(x => <any>{
                            title: "Annotation ({0})".format((visibleAnnotations.indexOf(x) + 1).toString()),
                            text: x.truncate(22), 
                            icon: Icons.Annotations.BadgeIcon});
                    }
                    if(card.Color != null) {
                        var color = await config(t).applyAnnotationFilter([card.Color]);
                        if(color.length > 0) {
                            badges.push({title: "Color", text: color[0].truncate(22), icon: Icons.Annotations.BadgeIcon})
                        }
                    }
                }
            }
        }

        return badges;
    }
}

export var annotationsModule = new AnnotationsModule();
export default annotationsModule;
